export default __webpack_public_path__ + "static/media/walkspot.dc4a80fa.svg";